export enum CertificateType {
    Unknown = -1,
    FirstCertif,
    Prolongation,
    Relapse
}